import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=d3d75ebc"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports